export const blockIconsAudioandvideoFiberManualRecordNew = (
	<span className='material-symbols-outlined'>fiber_manual_record</span>
);
